import { AUTH_ACTIONS, requireCustomerAuth, handleInsufficientCallCredits } from "../utils/protectedAuthAction";
import { showToast } from "../utils/toast";
import { useExotelVoiceCall } from "./useExotelVoiceCall";

export function useMarketplaceExotelCall({
  navigate,
  authOptionsFor,
  handleFreemiumError,
  refreshFreemium,
  runGatedCall,
  openExhausted,
} = {}) {
  const { callBusy, placeCall, inAppCallSheet } = useExotelVoiceCall();

  async function startLoggedInCall(caregiver) {
    if (!caregiver?.id || callBusy) return;

    const peerName = caregiver.name || caregiver.fullName || "Caregiver";

    const executeCall = async () => {
      try {
        const result = await placeCall({
          caregiverId: caregiver.id,
          calleeUserId: caregiver.userId,
          marketplace: true,
          peerName,
          peerPhotoUrl: caregiver.photoUrl || caregiver.profileImageUrl || "",
        });
        if (!result) return false;
        if (result.mode === "webrtc" || result.mode === "tel" || result.mode === "click2call") {
          refreshFreemium?.();
          return true;
        }
        showToast.error(result.message || "Unable to start the call.");
        return false;
      } catch (err) {
        if (
          handleInsufficientCallCredits(err, navigate, authOptionsFor?.(caregiver) || {}, {
            openExhausted: (quota) =>
              openExhausted?.({ quota, peerName, onRetry: () => startLoggedInCall(caregiver) }),
          })
        ) {
          return false;
        }
        if (!handleFreemiumError?.(err)) {
          showToast.error(err?.body?.message || err?.message || "Unable to start the call.");
        }
        return false;
      }
    };

    if (runGatedCall) {
      await runGatedCall({ peerName, action: executeCall });
      return;
    }
    await executeCall();
  }

  function startCall(caregiver) {
    if (!caregiver?.id) return;
    const options = {
      action: AUTH_ACTIONS.CALL,
      tab: "create",
      ...(authOptionsFor?.(caregiver) || {}),
    };
    if (!requireCustomerAuth(navigate, options)) return;
    startLoggedInCall(caregiver);
  }

  return {
    callBusy,
    startCall,
    inAppCallSheet,
  };
}
